import { selfDestruct } from "./Destory.js";

function extraClick({ gameState, event }) {
  gameState.maxClicks++;
  selfDestruct(event)
}

export default extraClick;
